import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render schedule section for FAQ Page
 */
const ScheduleSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="schedule-section-component"
    >
      <AccordionV2
        testId="schedule"
        className="border-none pb-4 pt-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="What is the schedule of the Singapore Corporate Awards?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            For each award year, typically the nominations are open in February.
          </p>

          <p>
            The selection and judging process which involves several stages will
            take place from late March to about June.
          </p>

          <p>
            The SCA gala dinner is usually held in July and August depending
            upon the availability of the guest of honour and venue.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ScheduleSection;
